import { render, staticRenderFns } from "./AppFrame.vue?vue&type=template&id=986eacd2&scoped=true&"
import script from "./AppFrame.vue?vue&type=script&lang=js&"
export * from "./AppFrame.vue?vue&type=script&lang=js&"
import style0 from "./AppFrame.vue?vue&type=style&index=0&id=986eacd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986eacd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDialog,VProgressLinear,VRow})
